import {
  ComponentDescriptorOrArray,
  getRendererFromDescriptor,
} from '@kizi/comparator-core';
import { Div, P } from '@kizi/core-components';
import React from 'react';

export interface TileRadioLabelWithChildrenProps {
  direction: 'horizontal' | 'vertical';
  text: string;
  subText?: string;
  icon?: string;
  children?: ComponentDescriptorOrArray;
}

export const TileRadioLabelWithChildren: React.FC<
  TileRadioLabelWithChildrenProps
> = ({ text, subText, children }): JSX.Element => {
  return (
    <Div
      css={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
      }}
    >
      <Div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <P variant="bodyImportant">{text}</P>
        {subText && (
          <P variant="captionRegular" color="#727888">
            {subText}
          </P>
        )}
      </Div>

      {children ? <Div>{getRendererFromDescriptor(children)}</Div> : null}
    </Div>
  );
};
